<template>
	<div class="patient_result bg-white">
		<base-result v-if="$route.params.type === 'success'" text="绑定成功">
			<van-button type="primary" block @click="$router.push('/')">去首页</van-button>
		</base-result>
	</div>
</template>

<script>
	export default {
		name: 'patient-result',
	};
</script>

<style scoped lang="less">
	.patient_result {
		min-height: 100vh;
		padding: 0 40px;
	}
</style>
